/**
 * TransmissionResultBadge — one transmission attempt's result (sheet 32
 * callouts 6, 9 and 10, sheet 31 callout 15; mission 7 WP08 T044; FR-013,
 * FR-014; TX.6; contracts/ui-api.md "Spine, part 2"; squad U10).
 *
 * The §2.6 tones through the §7.4 `Badge`, labelled by `resultLabel.*`:
 * success is success; pending ("Sending") is info with no dot, because §2.6
 * gives the dot to Running only; auth_failed and timeout are error; not_sent is
 * warning. The Sending label and the Not sent tone are flagged to the design
 * owner (`rulingBy: ['design']` on both register entries; research §3).
 */
import { Badge } from '@/components/ui/badge'
import type { TransmissionResult } from '@/lib/api/transmissions'
import { copyText, type TextKey } from '@/lib/provisional-copy'

const RESULT: Record<TransmissionResult, { tone: 'success' | 'info' | 'warning' | 'error'; label: TextKey }> = {
  success: { tone: 'success', label: 'resultLabel.success' },
  pending: { tone: 'info', label: 'resultLabel.pending' },
  auth_failed: { tone: 'error', label: 'resultLabel.authFailed' },
  timeout: { tone: 'error', label: 'resultLabel.timeout' },
  not_sent: { tone: 'warning', label: 'resultLabel.notSent' },
}

export function TransmissionResultBadge({ result }: { result: TransmissionResult }) {
  const { tone, label } = RESULT[result]
  return (
    <Badge status={tone} data-transmission-result={result}>
      {copyText(label)}
    </Badge>
  )
}
